module.exports = __webpack_public_path__ + "img/ico30.85d5701b.jpg";